import { ModalTypes } from 'application/providers/ModalProvider';
import { CompanyTagPureType } from 'domain/api/graphql/generated';

type ISourcefileType = {
  extension: string;
};
export interface IVideoMediafile {
  id?: string | null;
  title?: string | null;
  previewUrl?: string | null;
  playDuration?: number | null;
  duration?: number | null;
  uploading?: boolean;
  isCopy?: boolean;
  type?: number | null;

  sourcefiles?: ISourcefileType[];

  mediafile?: {
    id: string;
    sourcefiles?: ISourcefileType[];
    duration?: number | null;
    uri?: string;
    type?: number | null;
  };
}

export interface IVideoStreamShort {
  id?: string;
  title?: string | null;
  description?: string | null;
  videoMediafiles?: IVideoMediafile[];
  isDefault?: boolean;
  isGroupSlave: boolean;
  devicesGroup?: {
    id: string;
    title: string;
    isValid: boolean;
    masterVideoStream?: { id?: string | number } | null;
    validationError?: string | null;
  } | null;
}

export type VideoStreamBindModalProps = {
  selectedPoints: PointsListDataItem[];
  isButtonLoading: boolean;
  bindVideoStream: (selectedPoints: PointsListDataItem[]) => Promise<void>;
  openSuccessModal: (selectedPoints: PointsListDataItem[]) => void;
  openModal: (modalType: ModalTypes, props: {}) => void;
  isDenyCreatePoint: boolean;
  selectedPoint?: SelectedPoint;
  setCurrentSelectedPointPoint?: (point?: SelectedPoint) => void;
};

export type PointsListDataItem = {
  id: string;
};

export interface IDraggableVideoMediafile extends IVideoMediafile {
  id: string;
}

export enum VideoStreamFlow {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export type PointsListCheckboxGroupPointType = {
  id: string;
  title?: string;
  address?: string;

  description?: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  tags?: CompanyTagPureType[] | null;
};

export interface SelectedPoint {
  pointId: string;
  pointAddress?: string;
}

export interface IVideoStreamTag {
  id: string;
  title: string;
  companyId: string;
}
